import request from 'utils/request'

export const mcars080InitRequest = () =>
  request({
    url: '/MCARS080/init',
    method: 'post',
})